import { Box, Text, Tooltip, UserAvatar, useToggle } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { Participant } from 'modules/form_answers/lib/types'

export const ParticipantCell: React.FC<{ participant: Participant; anonymous?: boolean }> = ({
  participant,
  anonymous,
}) => {
  const [isHovering, toggleHovering] = useToggle(false)
  const backgroundColor = isHovering ? 'grey200' : 'lighter000'

  const showTooltip = participant.respondent.id !== participant.targetId

  return (
    <>
      {anonymous || !participant.targetId ? (
        <Box
          padding="s16"
          borderRadius={{
            all: 'abs008',
          }}
          onMouseEnter={toggleHovering(true)}
          onMouseLeave={toggleHovering(false)}
          background={backgroundColor}
        >
          <Text size="300" weight="semibold" ellipsis>
            {i18n.t('form_answers.answers_table.participant')} {participant.participant?.id}
          </Text>
        </Box>
      ) : showTooltip ? (
        <Tooltip.Alt
          label={`Answered by: ${participant.respondent.fullName}`}
          open={isHovering}
          toggle={toggleHovering}
          attachment="top center"
        >
          <Box
            background={backgroundColor}
            onMouseEnter={toggleHovering(true)}
            onMouseLeave={toggleHovering(false)}
            flexDirection="row"
            padding="s16"
            borderRadius={{
              all: 'abs008',
            }}
          >
            <UserAvatar label="" url={buildUrl(participant.participant?.avatar)} />
            <Box alignItems="flexStart" flexDirection="column" paddingX="s16" textAlign="left">
              <Text size="300" weight="semibold" ellipsis>
                {participant.participant?.fullName}
              </Text>
              <Box textAlign="left">
                <Text ellipsis size="300">
                  {participant.participant?.trainingClassName}
                </Text>
              </Box>
            </Box>
          </Box>
        </Tooltip.Alt>
      ) : (
        <Box
          background={backgroundColor}
          onMouseEnter={toggleHovering(true)}
          onMouseLeave={toggleHovering(false)}
          flexDirection="row"
          padding="s16"
          borderRadius={{
            all: 'abs008',
          }}
        >
          <UserAvatar label="" url={buildUrl(participant.participant?.avatar)} />
          <Box alignItems="flexStart" flexDirection="column" paddingX="s16">
            <Text size="300" weight="semibold" ellipsis>
              {participant.participant?.fullName}
            </Text>
            <Box textAlign="left">
              <Text ellipsis size="300">
                {participant.participant?.trainingClassName}
              </Text>
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}
